function convertMinuteToYear(num) {
  let eq =
    "Converting " +
    num +
    " minute to year: \n" +
    num +
    " * 0.0000019013243104087 = ";
  let rep = num * 0.0000019013243104087;
  return eq + rep.toFixed(7);
}

function convertMinuteToWeek(num) {
  let eq =
    "Converting " +
    num +
    " minute to week: \n" +
    num +
    " * 0.0000992063492063492 = ";
  let rep = num * 0.0000992063492063492;
  return eq + rep.toFixed(5);
}

function convertMinuteToSecond(num) {
  let eq =
    "Converting " +
    num +
    " minute to second: \n" +
    num +
    " * 60 = ";
  let rep = num * 60;
  return eq + rep.toFixed(2);
}

function convertMinuteToMonth(num) {
  let eq =
    "Converting " +
    num +
    " minute to month: \n" +
    num +
    " * 0.000022815891724904232 = ";
  let rep = num * 0.000022815891724904232;
  return eq + rep.toFixed(6);
}

function convertMinuteToHour(num) {
  let eq =
    "Converting " +
    num +
    "  minute to hour: \n" +
    num +
    " * 0.016666666666666666 = ";
  let rep = num * 0.016666666666666666;
  return eq + rep.toFixed(3);
}

function convertMinuteToDay(num) {
  let eq =
    "Converting " +
    num +
    " minute to day: \n" +
    num +
    " * 0.0006944444444444445 = ";
  let rep = num * 0.0006944444444444445;
  return eq + rep.toFixed(5);
}

export {
  convertMinuteToDay,
  convertMinuteToHour,
  convertMinuteToMonth,
  convertMinuteToSecond,
  convertMinuteToWeek,
  convertMinuteToYear
};
